import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.some.js";
import BillingService from '@/services/BillingService';
import BillingList from '@/components/billing/List';
export default {
  components: {
    BillingList
  },
  data: () => {
    return {
      loading: false,
      billing: [],
      transactions: [],
      states: [],
      countries: [],
      address: null,
      w9: null,
      validated: false,
      transactionFields: [{
        key: 'id',
        label: 'ID'
      }, 'created', {
        key: 'transactiontypename',
        label: 'Type'
      }, 'info', 'amount']
    };
  },
  filters: {
    // Vue-2 style filter; Vue 3 compat MODE 2 keeps the | currency syntax
    // working as long as the filter resolves locally or globally. Defining
    // here avoids relying on a global registration that doesn't exist.
    currency(value) {
      const n = Number(value);
      if (!Number.isFinite(n)) return '';
      return n.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD'
      });
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.loading = true;
      BillingService.init().then(response => {
        this.billing = response.data.results;
        this.transactions = response.data.transactions;
        this.w9 = response.data.w9;
        this.states = response.data.states;
        this.countries = response.data.countries;
        this.address = response.data.address;
        if (this.billing && this.billing.length > 0) {
          this.billing.some(b => {
            if (b.validated !== 0) {
              this.validated = true;
              return true;
            }
            return false;
          });
        }
      }).catch(error => {
        this.$aim.error(error.response);
      }).finally(() => {
        this.loading = false;
      });
    },
    bgClass: function (billing) {
      let output = 'alert alert-info';
      if (+billing.validated !== 1) {
        output = 'alert alert-danger';
      } else if (billing.daysexpire < 30) {
        output = 'alert alert-warning';
      } else if (+billing.expvalid === 0) {
        output = 'alert alert-danger';
      } else if (billing.default_payment_method) {
        output = 'alert alert-success';
      }
      return output;
    },
    getSource: function (type) {
      return `/img/cc/lg/${type}.png`;
    }
  }
};